import 'jquery-ujs';

import HeaderModule from './common/header';
import setupFilters from './common/filters';
import limitPagination from './common/pagination';
import ComponentsModule from './components/components';

document.addEventListener('DOMContentLoaded', () => {
  // Components
  ComponentsModule();
  // Header
  HeaderModule();
  // Paginations Limit Handler 
  limitPagination();
  // set filter
  setupFilters();
});



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/application.js